// Phase-104 · Micro Hub Lead orders page.
// /dashboard/microhub/orders · gated by RoleGate; ops_staff = read-only.
import useAuthStore from "../../store/authStore";
import RoleGate from "../../components/RoleGate";
import HubOrdersTable from "../../components/HubOrdersTable";

function Inner() {
  const role = useAuthStore((s) => s.user?.role);
  const readonly = role === "ops_staff";
  return (
    <HubOrdersTable
      variant="microhub"
      title="Micro Hub · Orders"
      subtitle="Orders routed through your micro hub. Assign agents and progress statuses."
      readonly={readonly}
      iconColor="text-blue-600"
      iconBg="bg-blue-50"
      iconBorder="border-blue-200"
    />
  );
}

export default function MicroHubOrders() {
  return (
    <RoleGate allow={["micro_hub_lead", "ops_staff"]}>
      <Inner />
    </RoleGate>
  );
}
